

















































































































































import { library } from '@fortawesome/fontawesome-svg-core'
import { faCopy } from '@fortawesome/free-solid-svg-icons'

library.add(faCopy)

import {
  defineComponent,
  ref,
  inject,
  onMounted,
  computed
} from '@vue/composition-api'
import { useRouter } from '@u3u/vue-hooks'
import { ClientAdminApiKey } from '@/rest/client-admin-api'
import { LanguageApiKey } from '@/rest/language-api'
import KaiFormInput from '@/contexts/frontend/KaiFormInput.vue'
import KaiFormSelect from '@/contexts/frontend/KaiFormSelect.vue'
import {
  handleApiResponse,
  ServerError,
  ValidationError
} from '@/rest/responses'
import {
  ConversationsApiKey,
  validateUpdatedConversation,
  validateNewConversation
} from '@/rest/conversations-api'
import KaiCheckbox from '../frontend/KaiCheckbox.vue'

const toSelectOption = (input: any) => ({
  value: input.id,
  display: input.name
})
const toSelectOptionLang = (input: any) => ({
  id: input.value,
  label: input.label
})

const findByValue = (
  items: Array<{ value: string; display: string }>,
  id: string
) => items.find(item => item.value == id)

export default defineComponent({
  components: {
    KaiFormInput,
    KaiFormSelect,
    KaiCheckbox
  },

  props: {
    conversationId: Number
  },

  setup(props) {
    const title = ref('')
    const description = ref('')
    const date = ref(new Date(Date.now()))
    const messages = ref([])
    const messageType = ref('none')
    const fieldErrors = ref({})
    const { router } = useRouter()
    const clientAdminApi = inject(ClientAdminApiKey)
    const languageApi = inject(LanguageApiKey)
    const conversationsApi = inject(ConversationsApiKey)
    const clients = ref([])
    const selectedClient = ref('')
    const users = ref([])
    const selectedOwner = ref('')
    const projects = ref([])
    const selectedProject = ref('')
    const teams = ref([])
    const selectedTeam = ref('')
    const isSaved = ref(false)
    const conversationId = ref<number | undefined>()
    const published = ref(false)
    const status = ref('pending')
    const firstPartyLabel = ref('KAM')
    const secondPartyLabel = ref('HCP')
    const selectedType = ref('')
    const loading = ref(null)
    const conversationTypes = [
      {
        id: 'sales',
        name: 'Sales'
      },
      {
        id: 'sem',
        name: 'SEM'
      },
      {
        id: 'grow',
        name: 'GROW'
      },
      {
        id: 'sanofisales',
        name: 'Sanofi Sales'
      }
    ].map(toSelectOption)

    const selectedLanguage = ref('en-gb')
    const languages = [].map(toSelectOption)

    const validationError = (error: ValidationError) => {
      messages.value = error.formErrors
      messageType.value = 'danger'
    }

    const serverError = (error: ServerError) => {
      messages.value = [error.message]
      messageType.value = 'danger'
    }

    onMounted(async () => {
      const promises = []

      promises.push(
        languageApi.GetLanguages().then(results => {
          results.map(toSelectOptionLang)
          results.map(lang =>
            languages.push({
              value: lang.value,
              display: lang.label
            })
          )
        })
      )

      promises.push(
        clientAdminApi
          .ListClients()
          .then(results => results.map(toSelectOption))
          .then(results => (clients.value = results))
      )

      promises.push(
        clientAdminApi
          .ListUsers()
          .then(results => results.map(toSelectOption))
          .then(results => (users.value = results))
      )

      promises.push(
        clientAdminApi
          .ListProjects()
          .then(results => results.map(toSelectOption))
          .then(results => (projects.value = results))
      )

      promises.push(
        clientAdminApi
          .ListTeams()
          .then(results => results.map(toSelectOption))
          .then(results => (teams.value = results))
      )

      if (props.conversationId != undefined) {
        promises.push(
          conversationsApi.GetConversation(props.conversationId).then(
            handleApiResponse({
              success: result => {
                const conversation = result[0]
                conversationId.value = conversation.id
                title.value = conversation.title
                description.value = conversation.description
                date.value =
                  conversation.date != null && conversation.date != ''
                    ? new Date(Date.parse(conversation.date))
                    : null
                firstPartyLabel.value = conversation.first_party_label
                secondPartyLabel.value = conversation.second_party_label
                selectedType.value = conversation.type
                selectedLanguage.value = conversation.language
                selectedClient.value = conversation.client_id
                selectedOwner.value = conversation.owner_id
                selectedProject.value = conversation.project_id
                selectedTeam.value = conversation.team_id
                published.value =
                  conversation.status === 'published' ? true : false
                status.value = conversation.status
                isSaved.value = true
              },
              validationError,
              serverError
            })
          )
        )
      }

      loading.value = Promise.all(promises)
    })

    const conversationIdFormatted = computed(() =>
      isSaved.value ? conversationId.value : '(none)'
    )
    const copyConversationId = () =>
      navigator.clipboard.writeText(conversationId.value.toString())

    const back = () => router.go(-1)

    const save = async () => {
      // publish logic, and only allow calls in committed status to be published
      if (published.value === true && status.value !== 'committed') {
        messages.value = ["Call status must be 'committed' to publish a call"]
        messageType.value = 'danger'
        return
      } else if (published.value === true) status.value = 'published'
      else if (published.value === false && status.value === 'published') {
        status.value = 'committed'
      }

      if (isSaved.value === true) {
        try {
          const validated = validateUpdatedConversation({
            title: title.value,
            description: description.value,
            date: date.value.toDateString(),
            type: selectedType.value,
            language: selectedLanguage.value,
            first_party_label: firstPartyLabel.value,
            second_party_label: secondPartyLabel.value,
            owner_id: selectedOwner.value,
            owner_display_name: findByValue(users.value, selectedOwner.value)
              ?.display,
            project_id: selectedProject.value,
            project_display_name: findByValue(
              projects.value,
              selectedProject.value
            )?.display,
            team_id: selectedTeam.value,
            team_display_name: findByValue(teams.value, selectedTeam.value)
              ?.display,
            status: status.value
          })
          if (validated._tag == 'success') {
            const apiResponse = await conversationsApi.UpdateConversation(
              conversationId.value,
              validated.data
            )
            if (apiResponse._tag == 'success') {
              messages.value = ['Conversation saved']
              messageType.value = 'success'
            } else if (apiResponse.error._tag == 'validation') {
              messages.value = apiResponse.error.formErrors
              messageType.value = 'danger'
            } else if (apiResponse.error._tag == 'server') {
              messages.value = [apiResponse.error.message]
              messageType.value = 'danger'
            }
          } else {
            throw validated
          }
        } catch (err) {
          fieldErrors.value = err.error.fieldErrors
          messages.value = err.error.fieldErrors.status
          messageType.value = 'danger'
          return false
        }
      } else {
        try {
          const validated = validateNewConversation({
            title: title.value,
            description: description.value,
            date: date.value.toDateString(),
            type: selectedType.value,
            language: selectedLanguage.value,
            first_party_label: firstPartyLabel.value,
            second_party_label: secondPartyLabel.value,
            client_id: selectedClient.value,
            client_display_name: findByValue(
              clients.value,
              selectedClient.value
            )?.display,
            owner_id: selectedOwner.value,
            owner_display_name: findByValue(users.value, selectedOwner.value)
              ?.display,
            project_id: selectedProject.value,
            project_display_name: findByValue(
              projects.value,
              selectedProject.value
            )?.display,
            team_id: selectedTeam.value,
            team_display_name: findByValue(teams.value, selectedTeam.value)
              ?.display,
            status: status.value
          })
          if (validated._tag == 'success') {
            const apiResponse = await conversationsApi.CreateConversation(
              validated.data
            )
            if (apiResponse._tag == 'success') {
              const conversation = apiResponse.data
              messages.value = ['Conversation created']
              messageType.value = 'success'
              conversationId.value = conversation.id
              isSaved.value = true
            } else if (apiResponse.error._tag == 'validation') {
              messages.value = apiResponse.error.formErrors
              messageType.value = 'danger'
            } else if (apiResponse.error._tag == 'server') {
              messages.value = [apiResponse.error.message]
              messageType.value = 'danger'
            }
          } else {
            throw validated
          }
        } catch (err) {
          fieldErrors.value = err.error.fieldErrors
          messages.value = ['Form validation failed']
          messageType.value = 'danger'
          return false
        }
      }
    }

    return {
      loading,
      back,
      save,
      fieldErrors,
      copyConversationId,
      conversationIdFormatted,
      title,
      description,
      date,
      clients,
      selectedClient,
      users,
      selectedOwner,
      projects,
      selectedProject,
      teams,
      selectedTeam,
      messages,
      messageType,
      isSaved,
      selectedType,
      conversationTypes,
      selectedLanguage,
      languages,
      firstPartyLabel,
      secondPartyLabel,
      published
    }
  }
})
